
.oauthIntegrations {
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    align-items: center;

    @media (min-width: 768px) {
        flex-direction: row;
        flex-wrap: wrap;
    }
}

.oauthIntegrationsLoading,
.oauthIntegrationsError {
    padding: 16px;
    text-align: center;
    border-radius: 4px;
}

.oauthIntegrationsLoading {
    background-color: #f8f9fa;
    color: #6c757d;
}

.oauthIntegrationsError {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.oauthIntegrationButton {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 1rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    height: 45px;
    cursor: pointer;
    transition: opacity 0.4s ease, transform 0.2s ease;
    width: 100%;

    @media (min-width: 768px) {
        flex: 1;
        min-width: 200px;
        max-width: 220px;
    }

    &:hover {
        &:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }

    &:active {
        &:not(:disabled) {
            transform: translateY(0);
            box-shadow: 0 0 0 rgba(0, 0, 0, 0);
        }
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    img {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }
    span {
        flex: 1;
        text-align: center;
    }
}